<template>
    <div class="b1">
        <div class="bg"></div>
        <div class="box">
            <div class="top">
                <div class="t_item">
                    <div>姓名：</div>
                    <el-input placeholder="请输入内容" v-model="nickName"></el-input>
                </div>
                <div class="t_item">
                    <div>手机号：</div>
                    <el-input placeholder="请输入内容" v-model="phonenumber"></el-input>
                </div>
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button type="primary" plain @click="reset">重置</el-button>
            </div>
            <div class="center">
                <div class="c_top">
                    <div class="ct_left">
                        我的账号
                        <span>剩余可建：{{ accountNum - useNum }}</span>
                    </div>
                    <div class="ct_right" @click="btn_add">添加账号</div>
                </div>
                <div class="c_bottom" :infinite-scroll-distance="50" :infinite-scroll-immediate="false"
                    v-infinite-scroll="load">
                    <div class="cb_top">
                        <div>头像</div>
                        <div>姓名</div>
                        <div>手机号</div>
                        <!-- <div>状态</div> -->
                        <div>任教学段</div>
                        <div>任教科目</div>
                        <div>所在学校</div>
                        <div>创建时间</div>
                        <div>操作</div>
                    </div>
                    <div class="cb_bottom" v-for="(item, index) in list" :key="index">
                        <div class="cbb_1">
                            <img :src="webImg + item.avatar" />
                        </div>
                        <div class="cbb_2">{{ item.nickName }}</div>
                        <div class="cbb_3">{{ item.phonenumber }}</div>
                        <!-- <div class="cbb_4">
                        <img src="../../assets/img/i86.png" />
                        </div> -->
                        <div class="cbb_5">{{ item.techSection }}</div>
                        <div class="cbb_6">{{ item.techSubject }}</div>
                        <div class="cbb_7">{{ item.schoolName }}</div>
                        <div class="cbb_8">{{ item.createTime }}</div>
                        <div class="cbb_9" @click="btn_unBind(item.userId)">解绑</div>
                    </div>
                    <el-empty description="暂无数据" v-if="list.length == 0"></el-empty>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { infoSchool, schoolUserList, schoolUserUnbind, schoolUserAdd } from '../../apis/index'
export default {
    data() {
        return {
            accountNum: 0,
            useNum:0,
            pageNum: 1,
            pageSize: 20,
            total: 0,
            list: [],
            nickName: '',
            phonenumber: ''
        }
    },
    mounted() {
        this.getInfo()
        this.getList()
    },
    methods: {
        search(){
            this.pageNum = 1
            this.getList()
        },
        reset(){
            this.nickName = ''
            this.phonenumber = ''
            this.pageNum = 1
            this.getList()
        },
        btn_add() {
            this.$prompt('请输入手机号', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^1[3-9]\d{9}$/,
                inputErrorMessage: '手机号格式不正确'
            }).then(({ value }) => {
                schoolUserAdd({
                    phonenumber:value
                }).then(res=>{
                    console.log(res,'schoolUserAdd');
                    this.$message.success('添加成功')
                    this.getInfo()
                    this.pageNum = 1
                    this.getList()
                })
            }).catch(() => {
                
            });
        },
        btn_unBind(userId) {
            this.$confirm('是否确认解绑该教师？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                schoolUserUnbind(userId).then(res => {
                    console.log(res, 'schoolUserUnbind');
                    this.$message({
                        type: 'success',
                        message: '解绑成功!'
                    });
                    this.pageNum = 1
                    this.getList()
                })
            }).catch(() => {
            });
        },
        load() {
            this.throttle(() => {
                if (this.total > this.list.length) {
                    this.pageNum++
                    this.getList()
                }
            })
        },
        getList() {
            schoolUserList(this.pageNum, this.pageSize, { nickName: this.nickName, phonenumber: this.phonenumber }).then(res => {
                console.log(res, 'schoolUserList');
                if (this.pageNum == 1) {
                    this.list = []
                }
                this.list = [...this.list, ...res.data]
                this.total = res.total
            })
        },
        getInfo() {
            infoSchool().then(res => {
                console.log(res, 'infoSchool');
                this.accountNum = res.data.accountNum
                this.useNum = res.data.useNum
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.b1 {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 1;

    .bg {
        width: 100%;
        height: 228px;
        background: linear-gradient(180deg, #F3F5FA 0%, #FFFFFF 100%);
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
    }
}

.box {
    width: 1200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding: 40px 0;

    .top {
        width: 100%;
        display: flex;
        align-items: center;

        .t_item {
            width: 300px;
            display: flex;
            align-items: center;
            margin-right: 40px;

            div {
                white-space: nowrap;
                font-weight: 400;
                font-size: 11px;
                color: #333333;
            }
        }
    }

    .center {
        width: 100%;
        height: 0;
        flex: 1;
        display: flex;
        flex-direction: column;

        .c_top {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 40px 0;

            .ct_left {
                display: flex;
                align-items: center;
                font-weight: bold;
                font-size: 18px;
                color: #000000;

                span {
                    font-weight: 500;
                    font-size: 12px;
                    color: #999999;
                    margin-left: 18px;
                }
            }

            .ct_right {
                width: 92px;
                height: 32px;
                background: #399AFF;
                border-radius: 7px 7px 7px 7px;
                font-weight: 800;
                font-size: 14px;
                color: #FFFFFF;
                text-align: center;
                line-height: 32px;
                user-select: none;
                cursor: pointer;
            }
        }

        .c_bottom {
            width: 100%;
            height: 0;
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow-y: scroll;

            .cb_top {
                width: 100%;
                height: 37px;
                border-radius: 4px;
                background: #F4F6FB;
                display: flex;
                align-items: center;
                font-weight: bold;
                font-size: 12px;
                color: #657688;
                box-sizing: border-box;
                padding: 0 12px;

                div:nth-child(1) {
                    width: 106px;
                }

                div:nth-child(2) {
                    width: 176px;
                }

                div:nth-child(3) {
                    width: 190px;
                }

                // div:nth-child(4) {
                //     width: 70px;
                // }

                div:nth-child(4) {
                    width: 143px;
                }

                div:nth-child(5) {
                    width: 143px;
                }

                div:nth-child(6) {
                    width: 143px;
                }

                div:nth-child(7) {
                    width: 158px;
                }

                div:nth-child(8) {
                    width: 143px;
                }
            }

            .cb_bottom {
                width: 100%;
                height: 70px;
                display: flex;
                align-items: center;
                border-bottom: 1px solid #F2F3F5;
                // background-color: #fff;
                box-sizing: border-box;
                padding: 0 12px;

                .cbb_1 {
                    width: 106px;

                    img {
                        width: 44px;
                        height: 44px;
                        border-radius: 50%;
                    }
                }

                .cbb_2 {
                    width: 176px;
                }

                .cbb_3 {
                    width: 190px;
                }

                .cbb_4 {
                    width: 70px;

                    img {
                        width: 29px;
                        height: 18px;
                        cursor: pointer;
                    }
                }

                .cbb_5 {
                    width: 143px;
                }

                .cbb_6 {
                    width: 143px;
                }

                .cbb_7 {
                    width: 143px;
                }

                .cbb_8 {
                    width: 158px;
                }

                .cbb_9 {
                    width: 143px;
                    font-weight: 500;
                    font-size: 11px;
                    color: #CF1400;
                    cursor: pointer;
                    user-select: none;
                }
            }
        }
    }
}
</style>